<template>
<svg xmlns="http://www.w3.org/2000/svg" width="12.58" height="12.58" viewBox="0 0 12.58 12.58">
  <g id="Group_80" data-name="Group 80" transform="translate(-10966.216 45.993)">
    <path id="Path_147" data-name="Path 147" d="M10968.338-43.872l8.337,8.337" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
    <path id="Path_148" data-name="Path 148" d="M10968.338-43.872l8.337,8.337" transform="translate(11012.209 10932.803) rotate(-90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
  </g>
</svg>
</template>